export const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M15.9759 9.16675L12.1544 5.34526L13.3329 4.16675L19.166 9.99982L13.3329 15.8329L12.1544 14.6544L15.9754 10.8334H1.66602V9.16675H15.9759Z"
        fill="#3659E3"
      />
    </svg>
  );
};
